import { useEffect, useState } from "react";
import PageShell from "@/components/PageShell";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { pick } from "@/i18n/translations";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { WhatsappCTA } from "@/pages/Home";

export default function FAQ() {
    const { t, lang } = useLang();
    const [faqs, setFaqs] = useState([]);

    useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data || [])).catch(() => {}); }, []);

    return (
        <PageShell>
            <section className="relative bg-brand-green text-white overflow-hidden">
                <div className="absolute inset-0 grainy opacity-50" />
                <div className="container-x relative py-20 md:py-24">
                    <div className="eyebrow text-brand-yellow">{t.faq.eyebrow}</div>
                    <h1 className="mt-4 font-display font-extrabold text-4xl md:text-6xl text-balance max-w-3xl">{t.faq.title}</h1>
                    <p className="mt-5 text-white/80 max-w-2xl text-lg">{t.faq.body}</p>
                </div>
            </section>

            <section className="container-x py-20 max-w-3xl">
                <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
                    {faqs.map((f) => (
                        <AccordionItem key={f.id} value={f.id} className="rounded-2xl border border-black/5 bg-white px-5">
                            <AccordionTrigger data-testid={`faq-q-${f.id}`} className="text-left font-display text-base md:text-lg font-semibold hover:no-underline">
                                {pick(f.question, lang)}
                            </AccordionTrigger>
                            <AccordionContent className="text-brand-charcoal/75 text-sm md:text-base">
                                {pick(f.answer, lang)}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </section>

            <WhatsappCTA />
        </PageShell>
    );
}
